/**
 * Returns the path of a URL without query or hash.
 * @param url - Router URL or serialized UrlTree
 * @returns Path without query and hash
 */
export function pathFromUrl(url: string): string {
  return (url.split('?')[0] ?? url).split('#')[0] ?? url;
}

/**
 * Checks whether a URL belongs to the applicant platform.
 * @param url - Router URL or path
 * @returns True for logged-in platform routes
 */
export function isPlatformRoute(url: string): boolean {
  const path = pathFromUrl(url);
  return (
    path === '/dashboard' ||
    path.startsWith('/dashboard/') ||
    path === '/applications' ||
    path.startsWith('/applications/') ||
    path === '/jobs' ||
    path.startsWith('/jobs/') ||
    path === '/profile' ||
    path.startsWith('/profile/') ||
    path === '/settings' ||
    path.startsWith('/settings/')
  );
}

/**
 * Checks whether a URL is a public job detail (or nested job) page.
 * @param url - Router URL or path
 * @returns True for `/companies/:id/jobs/:jobId` routes
 */
export function isJobboardJobRoute(url: string): boolean {
  return /\/companies\/[^/]+\/jobs\/[^/]+/.test(pathFromUrl(url));
}
